import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id EABFE131-4690-406C-9042-EFCA33E97A00
 * name wall-sconce
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wall-sconce.svg
 * tags
 * - Home Automation 
 */
export const WallSconceIcon = createSvgIcon(<><path d="M11,4L7,13H19L15,4H11M4,14V22H6V19H14V14H12V17H6V14H4Z" /></>, 'WallSconceIcon');
export default WallSconceIcon